// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"e2eb2f5f","581":"42b29e66"}[chunkId] + ".chunk.js";
};